<template>
    <div class="view--single view-about" :class="{ next_: next }"
         v-swipe="{ deactive: 'inTransit' }"
         @scroll.prevent
         @touchmove.stop.prevent
         @wheel.stop.prevent
         @swipe="handleSwipe">
        <div class="pages">
            <about-landing ref="landing" :class="{ _transit: inTransit, _mounted: mount }" @next="next = true"/>
            <about-static ref="statics" :scrollable="! inTransit" @scroll="handleScroll"/>
        </div>
        <div class="background"></div>
        <div ref="landingStickersPos" class="stickers-pos">
            <about-landing-stickers ref="stickers"/>
        </div>
        <v-track title="About"/>
    </div>
</template>

<script>
import { swipe } from '@/directives/swipe'
import { store } from '@/stores'
import { actions } from '@/stores/programs'

import AboutLanding from './AboutLanding'
import AboutLandingStickers from './AboutLandingStickers'
import AboutStatic from './AboutStatic'

export default {
    name: 'LandingView',
    components: {
        AboutLanding,
        AboutStatic,
        AboutLandingStickers
    },
    directives: {
        swipe
    },
    data() {
        return {
            mount: false,
            inTransit: true,
            next: false,
        }
    },
    computed: {
        statics() {
            return this.$refs.statics
        }
    },
    methods: {
        async handleSwipe(e) {
            if (this.inTransit) {
                return
            }
            if (! this.next && e.detail === 'down') {
                this.inTransit = true
                this.next = true
                document.querySelector('.app-nav').classList.add('_force-bg')
                setTimeout(() => {
                    this.inTransit = false
                }, 750)
            }
            else if (this.next && e.detail === 'up') {
                this.inTransit = true
                this.next = false
                document.querySelector('.app-nav').classList.remove('_force-bg')
                setTimeout(() => {
                    this.inTransit = false
                }, 750)
            }
        },
        handleScroll() {
            const scrollTop = this.statics.getScrollTop() * .5
            this.$refs.landingStickersPos.style.transform = `translateY(-${scrollTop}px)`
            this.$refs.landingStickersPos.style.opacity = Math.max(100 - scrollTop, 0) / 100
        }
    },
    mounted() {
        setTimeout(async () => {
            this.mount = true
            await this.$refs.stickers.throwStickers()
            this.inTransit = false
        }, 650)
        this.statics.scrollWrapper.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        this.statics.scrollWrapper.removeEventListener('scroll', this.handleScroll)
    },
    async beforeRouteEnter(_, __, next) {
        await store.dispatch(actions.fetchItems)
        next()
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.view-about {
    &.next_ {
        .pages {
            transform: translateY(-100%);
        }
        .background {
            transform: translateY(-100%);
        }
        .about-stickers {
            transform: translateY(-75%);
        }
    }
}
.pages {
    height: 100%;
    overflow: visible;
    position: relative;
    transition: transform 750ms $ease;
    z-index: 2;
}
.stickers-pos {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
.background {
    width: 100%;
    height: 90vh;
    background: linear-gradient(to bottom, #7c6daf, #534389 41%, #342264) no-repeat;
    background-size: 100% 50%;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 750ms $ease;
}
.about-stickers {
    transition: transform 750ms $ease;
}
</style>